import {
    getBorder,
    getCssClasses,
    getIsHidden,
    getMargin,
    getPadding,
    getTextAlign
} from '../../utils'

export const configAgregator = (node) => {
    const iframe = node.querySelector('iframe')
    const wrapper = node.querySelector('[data-element="wrapper"]')

    return {
        url: iframe ? iframe.getAttribute('src') || null : null,
        mobVideoURL: iframe.getAttribute('data-mobile-video-source'),
        loop: iframe.getAttribute('data-video-loop'),
        maxWidth: node.childNodes[0].style.maxWidth || null,
        ...getTextAlign(node),
        ...getMargin(node),
        ...getBorder(wrapper),
        ...getPadding(wrapper),
        ...getCssClasses(node),
        ...getIsHidden(node)
    }
}

export default configAgregator
